import React from "react";
import { landingStyles } from "components/Landing/landingStyles";
import HeroBanner from "components/Marketing/Components/HeroBanner";
import Footer from "components/Footer";
import FeatureGrid from "./FeatureGrid";
import LogoConnection from "components/LogoConnection";
import { BUTTON_TAGS } from "utils/constants/ui";
import { cellGrow } from "constants/styles";
import PATHS from "utils/paths";
import Link from "next/link";

const MarketingIntegrationsStripe = () => {
  const heroProps = {
    header: [
      {
        copy: "The most"
      },
      {
        classes: "color-primary underline",
        copy: "advanced"
      },
      {
        copy: "no code Stripe payment tools."
      }
    ],
    action: {
      tag: BUTTON_TAGS.LINK,
      href: PATHS.SIGNUP,
      copy: "Signup",
      classes: {
        button:
          "fw6 br2 pa3 border-box input-reset ba bg-transparent pointer f4 dib link items-center flex flex-shrink-0 cell-grow"
      }
    },
    paddingBottom: 20,
    subheader:
      "Connect the full power of the Stripe API to our set of no code tools."
  };

  return (
    <div className="w-100 relative">
      <div className="mw8 center">
        <HeroBanner {...heroProps} />
        <div className="pb3">
          <Link href={PATHS.SIGNUP}>
            <div className="pointer cell-grow">
              <LogoConnection src="/assets/priceblocs_advancedLinksConnect.png" />
            </div>
          </Link>
        </div>
        <div className="pa3 pb5">
          <FeatureGrid />
        </div>
        <div className="pt5 hairline-1 bt">
          <Footer />
        </div>
      </div>
      <style jsx>{landingStyles}</style>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

export default MarketingIntegrationsStripe;
